export function slugifyHeading(s: string): string {
  return s
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");
}

export interface TocItem {
  id: string;
  label: string;
}

/** Section headings -> TOC entries, with the same ids the headings are given. */
export function tocFromHeadings(headings: string[]): TocItem[] {
  return headings.map((h) => ({ id: slugifyHeading(h), label: h }));
}

/**
 * "On this page", set the way a printed guide sets its contents: a small label, a rule,
 * and the section names. It was a rounded, tinted box with a list icon. On wide screens
 * it sits in the right-hand margin and stays in view; on a phone it is an ordinary list
 * above the first section, because a pinned block would eat a third of the screen.
 */
export function Toc({ items, className }: { items: TocItem[]; className?: string }) {
  if (items.length < 2) return null;
  return (
    <nav aria-labelledby="toc-label" className={className}>
      <p id="toc-label" className="label-caps border-b border-rule/70 pb-2 text-muted-foreground">
        On this page
      </p>
      <ol className="mt-3 space-y-2.5 text-sm leading-snug">
        {items.map((it) => (
          <li key={it.id}>
            <a
              href={`#${it.id}`}
              className="text-muted-foreground underline-offset-4 transition-colors hover:text-primary hover:underline"
            >
              {it.label}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}
